export const ANALYTIC_PANEL_COLORS = {
    renovation: '#ED811D',
    purchaseCosts: '#F1C40F',
    operatingCosts: '#9B59B6',
    saleCosts: '#0BAC25',
    financingCosts: '#3498DB',
    otherCosts: '#95A5A6',
    purchasePrice: '#0255AA'
} as const;
